import { render, staticRenderFns } from "./Backup.vue?vue&type=template&id=d46b9e32&scoped=true&"
import script from "./Backup.vue?vue&type=script&lang=js&"
export * from "./Backup.vue?vue&type=script&lang=js&"
import style0 from "./Backup.vue?vue&type=style&index=0&id=d46b9e32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46b9e32",
  null
  
)

export default component.exports